import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caf15ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-body-1" }, "Шаг 3. Выберите пункт выдачи карт - место вашей работы", -1))

import { CardIssuePointsService, Id, MunicipalEntitiesService } from '@prodcard/core'
import { VCardIssuePointSelect } from '../../../../src/components'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { SelectCardIssuePointOpts } from './interfaces'
import { useWatcherSavedRef } from '../../../helpers'
import { usePageResult, callPage } from '../../../helpers/useResult'

const key = 'defaultCardIssuePointId'

export default /*#__PURE__*/_defineComponent({
  __name: 'IssuePointSelectForm',
  props: {
    cardIssuePointService: {},
    municipalEntitiesService: {},
    loading: { type: Boolean, default: false }
  },
  emits: ["submit"],
  setup(__props: any, { emit }) {





const rules = {
  cardIssuePointId: {
    required: helpers.withMessage('Пункт выдачи карт не может быть пустым', required),
  },
}

const opts = useWatcherSavedRef<SelectCardIssuePointOpts>('selectCardIssuePointOpts', {
  cardIssuePointId: '',
})

const id = usePageResult<Id>(key)
if (id) {
  opts.value.cardIssuePointId = id
}

const validator = useVuelidate(rules, opts)

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) emit('submit', opts.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submit, ["prevent"]),
    disabled: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_unref(VCardIssuePointSelect), {
                modelValue: _unref(opts).cardIssuePointId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(opts).cardIssuePointId) = $event)),
                "card-issue-points-service": _ctx.cardIssuePointService,
                "municipal-entities-service": _ctx.municipalEntitiesService,
                "error-messages": _unref(validator).cardIssuePointId.$errors.map(e => e.$message).join(', '),
                disabled: _ctx.loading,
                label: "Пункт выдачи карт*"
              }, null, 8, ["modelValue", "card-issue-points-service", "municipal-entities-service", "error-messages", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("p", {
        class: _normalizeClass(["text-caption mt-2", { 'text-grey': _ctx.loading, 'text-medium-emphasis': !_ctx.loading }])
      }, [
        _createTextVNode(" Если вы не нашли нужный пункт выдачи карт в списке, "),
        _createElementVNode("span", {
          class: _normalizeClass([{ 'disabled text-grey': _ctx.loading }, "text-primary text-decoration-underline"]),
          style: {"cursor":"pointer"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(callPage)(key, '/card-issue-points/new', _ctx.$router)))
        }, "создайте", 2),
        _createTextVNode(" его ")
      ], 2),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit", "disabled"]))
}
}

})